import AppController from "./controller/app-controller";
import CookieConsentConfig from "./utils/cookieconsent-config";
import { pushGoogleConsentUpdate } from "./utils/consent-gtm";
import { initContactFormTracking } from "./utils/tracking";

async function initCookieConsent() {
    const lang = document.documentElement.getAttribute('lang') || 'fr';
    CookieConsentConfig.language.default = lang.split('-')[0];

    const CookieConsent = await import('vanilla-cookieconsent');
    window.CookieConsent = CookieConsent;

    const syncGoogleConsent = () => {
        pushGoogleConsentUpdate(CookieConsent.acceptedCategory('analytics'));
    };

    CookieConsentConfig.onFirstConsent = syncGoogleConsent;
    CookieConsentConfig.onConsent = syncGoogleConsent;
    CookieConsentConfig.onChange = syncGoogleConsent;

    await CookieConsent.run(CookieConsentConfig);
    syncGoogleConsent();
}

document.addEventListener("DOMContentLoaded", async function () {
    initContactFormTracking();

    const app = new AppController();
    // Exposer l'app globalement pour les méthodes statiques
    window.app = app;
    window.appController = app;

    await initCookieConsent();

    var loaderKey = 'greensolver-loader',
        lastLoader = parseInt(localStorage.getItem(loaderKey), 10),
        nowDate = Date.now();

    /* Every 10 min */
    if (lastLoader && nowDate < lastLoader + 1000 * 60 * 10) {
        return;
    }

    /* Mark loader */
    localStorage.setItem(loaderKey, nowDate);
    document.body.setAttribute('data-loader-show', 1);
    /* Trigger loader */
    setTimeout(function () {
        document.body.removeAttribute('data-loader-show');
    }, 2000);

});
